import { ChevronDown, ChevronUp, Redo2, RotateCcw, Settings2, Undo2 } from 'lucide-react'
import { Button, Tabs, type TabItem } from '@/components/ds2'
import type { TemplateEditorMode } from '../constants/templateEditor'
import { TemplateAiActions } from './TemplateAiActions'

interface TemplateEditorModeBarProps {
    advancedOpen: boolean
    editorMode: TemplateEditorMode
    editorModes: TabItem[]
    subject: string
    html: string
    onModeChange: (mode: string) => void
    onToggleAdvanced: () => void
    onUndo: () => void
    onRedo: () => void
    onReset: () => void
    onPasteAiResult: (plainText: string, html: string) => boolean
}

export const TemplateEditorModeBar = ({
    advancedOpen,
    editorMode,
    editorModes,
    subject,
    html,
    onModeChange,
    onToggleAdvanced,
    onUndo,
    onRedo,
    onReset,
    onPasteAiResult,
}: TemplateEditorModeBarProps) => (
    <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="flex flex-wrap items-center gap-2">
            {advancedOpen ? (
                <Tabs items={editorModes} selectedKey={editorMode} onSelectionChange={onModeChange} />
            ) : (
                <span className="text-sm font-medium text-foreground">{editorMode === 'visual' ? 'Visual editor' : 'Template preview'}</span>
            )}
            <Button
                variant={advancedOpen ? 'secondary' : 'ghost'}
                size="sm"
                prefix={<Settings2 size={16} />}
                suffix={advancedOpen ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
                onClick={onToggleAdvanced}
                aria-expanded={advancedOpen}
            >
                Advanced
            </Button>
        </div>
        <div className="flex flex-wrap items-center gap-1">
            {/* Always on offer: it is how the layout itself changes — Visual edits the text and fields inside it. */}
            <TemplateAiActions subject={subject} html={html} onPasteResult={onPasteAiResult} />
            <Button variant="ghost" size="sm" iconOnly aria-label="Undo body edit" title="Undo body edit" disabled={editorMode !== 'visual'} onClick={onUndo}>
                <Undo2 size={16} />
            </Button>
            <Button variant="ghost" size="sm" iconOnly aria-label="Redo body edit" title="Redo body edit" disabled={editorMode !== 'visual'} onClick={onRedo}>
                <Redo2 size={16} />
            </Button>
            <Button variant="ghost" size="sm" prefix={<RotateCcw size={16} />} onClick={onReset}>
                Reset to default
            </Button>
        </div>
    </div>
)
